module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-blind-43f6086c48aa9567a03ef605109002e3.svg";